import commonPostTypeConfig from "../../common/postTypes/category";

export default function initPostType({wapp}) {
    return wapp.client.postTypes.getPostType({
        name: "category",
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager(),
    });
}
